export enum BookingStatus {
  Confirmed = "Confirmed",
  Cancelled = "Cancelled",
  Unknown = "Unknown",
  Unconfirmed = "Unconfirmed",
}

// Translation mapping for booking statuses
export const BOOKING_STATUS_TRANSLATIONS = {
  [BookingStatus.Confirmed]: "CONFIRMADO",
  [BookingStatus.Cancelled]: "CANCELADO",
  [BookingStatus.Unknown]: "DESCONOCIDO",
  [BookingStatus.Unconfirmed]: "NO CONFIRMADO",
} as const;

// Color mapping for booking statuses
export const BOOKING_STATUS_COLORS = {
  [BookingStatus.Confirmed]: "#22c55e", // Green
  [BookingStatus.Cancelled]: "#ef4444", // Red
  [BookingStatus.Unknown]: "#6b7280", // Gray
  [BookingStatus.Unconfirmed]: "#f97316", // Orange
} as const;
